import { cloneDeep } from "lodash";
import moment from "moment";

export const addNotesToData = (dataEntry, notes, item, chartType, periodType) => {
    const data = cloneDeep(dataEntry);
    const dataDimension = data[0].length;

    addBarSeriesToItemOptions(item, dataDimension);
    
    const maxValue = maxChartScaleValue(data.reduce((acc, curr, index) => {
        if(index > 0) {
            const value = curr.reduce(chartType === 'AreaChart'? sumOddValues : maxOddValues, 0);
            return value > acc ? value : acc;
        } 
        return acc;
    }, 0));

    data.forEach((element, index) => addNotesToElement(element, index, notes, dataDimension, maxValue, periodType));

    return {data, maxValue, barWidth: defineBarWidth(data)};
}

const addBarSeriesToItemOptions = (item, dataDimension) => {
    if(item?.options?.series && !Object.keys(item?.options?.series).some((key) => item?.options?.series[key]?.type === 'bars')) {
        const keys = Object.keys(item?.options?.series);
        const lastKey = Number(keys[keys.length - 1]);
        item.options.series[(lastKey + 1).toString()] = { type: 'bars', color: "#FF7F7F", groupWidth: 2.5 };
    } else if (!item?.options?.series) {
        item.options.series = { [Math.floor(dataDimension/2).toString()]: { type: 'bars', color: "#FF7F7F", groupWidth: 2.5 } };
    }
}

const sumOddValues = (acc, curr, index) => {
    if(index % 2 !== 0) {
        return acc + curr;
    }
    return acc;
}

const defineBarWidth = (data) => {
    return `${Math.min(100, Math.max(2.5, Math.ceil((data.length/400)*100)))}%`;
}

const maxOddValues = (acc, curr, index) => {
    if(index % 2 !== 0) {
        return curr > acc ? curr : acc;
    }
    return acc;
}

const noteTooltip = (notes) => {
    const reversed = notes.toReversed();
    return `
        <div style="padding: 5px; display: flex; flex-direction: column">
        ${ 
            reversed.map((note) => `<span>${note.name} - ${moment(note.date).format("DD/MM/YY")}</span>`).join("")
        }
        </div>`;
}

const addNotesToElement = (element, index, notes, dataDimension, maxValue, periodType) => {
    if(index === 0) {
        element[dataDimension] = "Notas";
        element[dataDimension + 1] = {
            "role": "tooltip",
            "type": "string",
            "p": {
                "html": true,
                "role": "tooltip"
            }
        }
    } else {
        const dateNotes = notes?.filter((note) => filterNoteDate(note, element[0], periodType));
        if(dateNotes?.length) {
            element[dataDimension] = maxValue;
            element[dataDimension + 1] = noteTooltip(dateNotes);
        } else {
            element[dataDimension] = 0;
            element[dataDimension + 1] = "";
        }
    }
} 

const filterNoteDate = (note, date, periodType) => {
    if(periodType === "DAY") {
        return date === moment(note.date).format("DD/MM/YY");
    } else if (periodType === "WEEK") {
        return date === moment(note.date).startOf('isoweek').format("DD/MM/YY");
    }
    return date === moment(note.date).format("MM/YY");
}

const maxChartScaleValue = (maxValue) => {
    const digits = Math.floor(Math.log10(maxValue)) + 1;
    const firstDigit = Number(maxValue.toString()[0]);
    let scale = Math.pow(10, digits - 1);
    if (firstDigit >= 5) {
        scale *= 2;
    }
    const maxY = Math.ceil(maxValue / scale) * scale;
    if(maxValue / maxY < 0.7) {
        return maxY - (scale/2);
    }
    return maxY;
}

export const chartToSeries = {
    AreaChart: "area",
    LineChart: "line",
}